import { useQuery } from "@tanstack/react-query";
import {
  unitSearch,
  UnitSearchParams,
} from "common/api/citajteo/dl_unit/citajteo_unit";
import { QUERY_KEYS } from "constant/react_query";
import { useUnitSearchOptionsFromUrl } from "./useUnitSearchOptionsFromUrl";

type UnitSearchOptions = {
  initialSearch: boolean;
};

const INITIAL_UNIT_SEARCH_OPTIONS: UnitSearchOptions = {
  initialSearch: true,
};

export const useUnitSearchQuery = (
  searchParams?: UnitSearchParams,
  { initialSearch }: UnitSearchOptions = INITIAL_UNIT_SEARCH_OPTIONS
): { data: any; refetch: Function } => {
  const { data, refetch } = useQuery({
    queryKey: [QUERY_KEYS.CITAJTEO_DL_UNIT_SEARCH, searchParams],
    queryFn: async () => {
      const result = await unitSearch({ ...searchParams });
      return result;
    },
    enabled: initialSearch,
  });

  return { data, refetch };
};

export const useUnitSearch = (searchParams?: UnitSearchParams) => {
  const { data: unit } = useUnitSearchQuery(searchParams);

  const result = typeof unit !== "undefined" && unit !== "" ? unit : null;
  return result;
};

export const useUnitSearchRefetch = (
  searchParams?: UnitSearchParams
): { data: any; refetch: Function } =>
  useUnitSearchQuery(searchParams, { initialSearch: false });

export const useUnitUrlSearch = () => {
  const unitSearchParams = useUnitSearchOptionsFromUrl();
  const unitListResult = useUnitSearch(unitSearchParams);

  return unitListResult;
};
